import type { ViewScope } from "../../lib/scope";

// Wave 22 — inline chip rendered next to a page title when the tab's scope
// doesn't match the current global scope and had to be pinned to a fallback.
// e.g. Audit Dashboard is company-only, so when a user's global scope is
// "mine" the page renders with forcedScope="company" and this badge lets the
// user understand the pinning.
//
// Kept deliberately minimal — no icon, no dismiss, no tooltip-wrapper. Each
// consumer renders it in-line with the `<h1>`.
export function ScopePinnedBadge({ forcedScope }: { forcedScope: ViewScope }) {
  return (
    <span
      data-testid="scope-pinned-badge"
      data-scope={forcedScope}
      title={
        forcedScope === "company"
          ? "Showing company view — this tab doesn't support Mine"
          : "Showing my view — this tab doesn't support Company"
      }
      className="inline-flex items-center gap-1 text-[11px] font-medium bg-slate-100 text-slate-600 px-2 py-0.5 rounded"
    >
      Showing {forcedScope === "company" ? "company" : "my"} view
    </span>
  );
}
